/* FAST PASS · the line skip page (sections/ff-fast-pass.liquid, template page.fast-pass).

   Who is this? A personal code in the link (?pass=CODE, made in the Data Hub) finds its pass. With no code, a
   phone that already holds a spot on the waitlist (the waitlist page's saved token, ffq_live_v1) is recognised.
   Anybody else adds a first name and a number: somebody already in line is found by it, and anybody else is
   signed up through the Worker's own /queue/join (the same door and texts as the waitlist page) while the
   skip plays.

   The skip: their row lifts and hops up to #3 (Jan, 2026-10-12: "put them like 3rd instead and all 3 people are up
   now"). #1 and #2 keep their places, everybody from the old #3 down to just before them steps back one place
   (measured before and after the move, FLIP), and somebody already in the top three stays put. It lands with a gold
   ring and confetti in Jan's brand purple and blue, #1 to #3 all wear "Up now", and the spot opens right below.
   "{N} in line" under the names opens the whole waitlist in a panel. Checkout is the waitlist's own: the
   D&D Character Art variant with their waitlist token, so the portal matches the order to their spot, plus
   ff_source=fast-pass and the pass code. On a phone a buy bar slides up once the sizes have scrolled away.

   A line skip earned in the commission portal (kind "earned", code like BRANNOC-7Q2KX9, sql/QUEST-SKIP-01) is
   made out to the hero, and its ticket shows no photo and no seal (the player signed it). Before it opens: the ticket, a
   countdown on the server's clock, the exact opening time and a calendar link, Jan's plan for the hero (pose,
   mood, background, size), and no way to buy until it opens (the wait is the point). At the opening time the page asks the server again. While it is
   open: the same skip, from their real place when they are in line (in_line) and otherwise from the back of the
   line marked "If you joined today", the size they picked already chosen, "Expires" at its end, and checkout
   carries the quest session and the hero. After it ends: a plain ended page. An earned pass never shows the
   phone form.
   The ?pass= code leaves the address bar as soon as it is read (the section strips it before trackers load).

   Data doors: sql/WAITLIST-34-FAST-PASS.sql. Nothing here moves anybody in the line. Preview with nothing
   saved: ?ffp_preview=line (also claim, bought, off, and for an earned pass soon, earned, ended; past is a past
   client's pass before they claim, etsy an Etsy client's, and &ffp_past=1 makes line or bought a past client's). Reduced motion lands
   straight on the final state. */
(function () {
  'use strict';
  var root = document.getElementById('ffp'), cfgEl = document.getElementById('ffp-config');
  if (!root || !cfgEl) return;
  var CFG;
  try { CFG = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  var C = CFG.copy || {};
  function $(id) { return document.getElementById(id); }
  var RM = false;
  try { RM = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}
  function wait(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }
  function num(v) { var n = parseInt(v, 10); return isFinite(n) && n > 0 ? n : null; }
  var tapped = false;
  document.addEventListener('pointerdown', function () { tapped = true; }, { passive: true, capture: true });
  function buzz(p) { try { if (tapped && navigator.vibrate) navigator.vibrate(p); } catch (e) {} }

  /* ---------- saved on this phone ---------- */
  var PASS_KEY = 'ffp_pass_v1', LIVE_KEY = 'ffq_live_v1', PRIOR_KEY = 'ffq_prior_v1';
  function readJSON(k) { try { return JSON.parse(localStorage.getItem(k) || 'null'); } catch (e) { return null; } }
  function writeJSON(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  var UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
  /* Jan's passes are ten characters (WAITLIST-34). A line skip earned in the portal is the hero's letters, a
     hyphen and six more (QUEST-SKIP-01). */
  var CODE_JAN = /^[A-HJ-NP-Z2-9]{10}$/, CODE_EARNED = /^[A-Z]{2,12}-[A-HJ-NP-Z2-9]{6}$/;
  function passCode(v) { var c = String(v == null ? '' : v).trim().toUpperCase(); return CODE_JAN.test(c) || CODE_EARNED.test(c) ? c : null; }
  function isEarnedCode(v) { return CODE_EARNED.test(String(v || '')); }
  /* The quest's session id is a UUID; anything else that rides to checkout must be a plain short token. */
  function sessionId(v) {
    var s = String(v == null ? '' : v).trim();
    if (/^[0-9a-f-]+$/i.test(s) && s.indexOf('-') >= 0) return UUID.test(s) ? s : null;
    return /^[A-Za-z0-9_-]{8,64}$/.test(s) ? s : null;
  }
  function when(v) { var t = v ? Date.parse(v) : NaN; return isFinite(t) ? t : null; }

  var qs;
  try { qs = new URLSearchParams(window.location.search || ''); } catch (e) { qs = { get: function () { return null; } }; }
  var PREVIEW = String(qs.get('ffp_preview') || '').toLowerCase();
  if (!/^(line|claim|bought|off|soon|earned|ended|past|etsy)$/.test(PREVIEW)) PREVIEW = '';
  /* ?ffp_preview=past is a past client's pass before they claim, etsy the same for an Etsy client; &ffp_past=1 adds a
     past client to line or bought */
  var PREVIEW_PAST = PREVIEW === 'past' || PREVIEW === 'etsy' || (!!PREVIEW && qs.get('ffp_past') === '1');
  var PREVIEW_SHOP = PREVIEW === 'etsy' ? 'etsy' : 'shopify';
  if (PREVIEW === 'past' || PREVIEW === 'etsy') PREVIEW = 'claim';

  /* ---------- tracking: the store's own pixel and GTM, if the page has them ---------- */
  function track(step, extra) {
    try { window.dataLayer = window.dataLayer || []; window.dataLayer.push(Object.assign({ event: 'ff_fast_pass', ff_fast_pass_step: step }, extra || {})); } catch (e) {}
  }
  function pixel(kind, name, data) { try { if (!PREVIEW && typeof window.fbq === 'function') window.fbq(kind, name, data || {}); } catch (e) {} }

  /* ---------- the doors ---------- */
  function rpc(name, body, ms) {
    var ctl = window.AbortController ? new AbortController() : null;
    var t = setTimeout(function () { try { if (ctl) ctl.abort(); } catch (e) {} }, ms || 12000);
    return fetch(CFG.sb + '/rest/v1/rpc/' + name, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', apikey: CFG.sbKey, Authorization: 'Bearer ' + CFG.sbKey },
      body: JSON.stringify(body || {}),
      signal: ctl ? ctl.signal : undefined
    }).then(function (r) { clearTimeout(t); if (!r.ok) throw new Error('rpc ' + r.status); return r.json(); },
            function (e) { clearTimeout(t); throw e; });
  }
  /* The buy button's count rides along as the checkout opens, so it must survive the page leaving. */
  function rpcBeacon(name, body) {
    try {
      return fetch(CFG.sb + '/rest/v1/rpc/' + name, {
        method: 'POST', keepalive: true,
        headers: { 'Content-Type': 'application/json', apikey: CFG.sbKey, Authorization: 'Bearer ' + CFG.sbKey },
        body: JSON.stringify(body || {})
      }).catch(function () {});
    } catch (e) { return Promise.resolve(); }
  }
  function workerJoin(first, phone) {
    var ctl = window.AbortController ? new AbortController() : null;
    var t = setTimeout(function () { try { if (ctl) ctl.abort(); } catch (e) {} }, 30000);
    return fetch(String(CFG.queueApi || '').replace(/\/+$/, '') + '/queue/join', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ first_name: first, phone: phone }), signal: ctl ? ctl.signal : undefined
    }).then(function (r) { clearTimeout(t); return r.json(); }, function (e) { clearTimeout(t); throw e; });
  }

  /* ---------- state ---------- */
  var S = { stage: 'boot', code: null, kind: null, name: '', token: null, state: null, position: null, total: null,
            list: [], est: null, eta: null, order: null, joined: false, size: null, y0: 0,
            /* an earned pass only */
            signed: '', opensAt: null, endsAt: null, offset: 0, hasLine: false, inLine: false, plan: null, pick: null, questSession: null, heroId: null,
            /* a pass the studio made for a past buyer (FAST-PASS-PAST-CLIENT-01), and where they bought (-02) */
            past: false, shop: null };
  window.__ffp = { S: S };
  function earned() { return S.kind === 'earned'; }

  /* ---------- a past client's pass (Jan, 2026-10-23) ----------
     The page asks fastpass_past_client with the pass's own code. Only a pass made in the studio's Past buyers tab
     answers yes: the wait is crossed out with "Instant for past clients" after it, and the character quest and
     Jan's thank-you show at the bottom. Before that SQL runs the door is missing, the answer is no, and the page
     stays as it was. Once yes, it stays yes for this visit (a claim can hand them their spot's older pass). */
  /* FAST-PASS-PAST-CLIENT-02 also says where they bought: shop 'etsy' when every order was on Etsy (FondlyFramed),
     and that client gets their own line under the headline. pastSeen keeps each answer, so the claim form can
     draw the right line at once when the answer came in first. */
  var pastAsk = {}, pastSeen = {}, pastTracked = false;
  function pastFor(code) {
    if (!code || !CODE_JAN.test(code)) return Promise.resolve(null);
    if (!pastAsk[code]) pastAsk[code] = rpc('fastpass_past_client', { p_code: code }, 8000).then(function (r) {
      var a = r && r.ok && r.past === true ? { shop: r.shop === 'etsy' || r.shop === 'shopify' ? r.shop : null } : null;
      pastSeen[code] = a;
      return a;
    }, function () { return null; });
    return pastAsk[code];
  }
  function checkPast() {
    var code = S.code;
    pastFor(code).then(function (a) { if (a && S.code === code && !earned()) setPast(true, a.shop); });
  }
  /* the line under the headline on the claim form: an Etsy client's own, else everybody's */
  function claimLede() {
    var a = S.past ? { shop: S.shop } : (S.code && pastSeen[S.code]) || null;
    return a && a.shop === 'etsy' && !earned() && C.lede_etsy ? C.lede_etsy : C.lede_claim;
  }
  function setPast(on, shop) {
    var was = claimLede();
    S.past = !!on;
    S.shop = S.past ? shop || null : null;
    /* an answer that lands after the claim form is drawn changes its line once, with the usual soft swap */
    if (S.stage === 'claim' && claimLede() !== was) setRich($('ffp-lede'), claimLede(), S.name, true);
    if (S.past) root.setAttribute('data-past', ''); else root.removeAttribute('data-past');
    /* "Instant for past clients" waits in a template, so any other pass's wait line holds no extra words */
    var ins = $('ffp-instant'), tpl = $('ffp-instant-t');
    if (ins && tpl) {
      Array.prototype.slice.call(ins.childNodes).forEach(function (n) { if (n !== tpl) ins.removeChild(n); });
      if (S.past && tpl.content) ins.appendChild(tpl.content.cloneNode(true));
    }
    setText('ffp-wait-sk', S.past || $('ffp-wait').classList.contains('is-done') ? ', skipped' : '');
    setText('ffp-thanks-t', fill(C.thanks, S.name));
    if (S.past && !pastTracked) { pastTracked = true; track('past_client_shown'); }
  }
  /* the server's clock: the page counts down to its opening time, not the phone's */
  function serverNow() { return Date.now() + (S.offset || 0); }

  function nice(n) {
    var s = String(n || '').replace(/[\u0000-\u001f\u007f]/g, '').replace(/\s+/g, ' ').trim().slice(0, 40);
    return s ? s.charAt(0).toUpperCase() + s.slice(1) : '';
  }
  /* {name} becomes the first name. With no name: "{name}, Jan..." loses its opening, "out, {name}." loses its
     tail, "{name} is" reads "You are", anything else reads "you". */
  function fill(tpl, name) {
    var t = String(tpl || '');
    if (name) return t.replace(/\{name\}/g, name);
    t = t.replace(/^\{name\},\s*/, '').replace(/,\s*\{name\}(?=[.,!?]|$)/g, '').replace(/^\{name\} is /, 'You are ').replace(/\{name\}/g, 'you');
    return t.charAt(0).toUpperCase() + t.slice(1);
  }
  /* The name in the headline takes the Hall card's serif italic, built as nodes so a typed name is only text. */
  function setRich(el, tpl, name, soft) {
    if (!el) return;
    function put() {
      el.textContent = '';
      var t = String(tpl || '');
      if (!name || t.indexOf('{name}') < 0) { el.textContent = fill(t, name); return; }
      t.split('{name}').forEach(function (part, i) {
        if (i) {
          var em = document.createElement('em'); em.textContent = name;
          /* "{name}'s" keeps its 's in the italic; the display face would set it as a capital S */
          var poss = /^['’]s(?![a-z])/i.exec(part);
          if (poss) { em.textContent += poss[0]; part = part.slice(poss[0].length); }
          el.appendChild(em);
        }
        if (part) el.appendChild(document.createTextNode(part));
      });
    }
    if (!soft || RM) { put(); return; }
    el.classList.add('is-swap');
    setTimeout(function () { put(); el.classList.remove('is-swap'); }, 170);
  }
  function setText(id, txt) { var el = $(id); if (el) el.textContent = txt; }
  function say(txt) { setText('ffp-live', txt); }
  /* an earned pass's headline keeps "line skip" together on one line */
  function nb(t) { return String(t || '').replace(/line skip/g, 'line skip'); }

  /* An earned pass's words: {name} is the hero, {signed} the first name they signed with, {ends} the end of the
     hold in their own time. keep leaves {name} for setRich, so the headline sets the hero in the serif italic. */
  function fillE(tpl, keep) {
    var t = String(tpl || '');
    t = S.signed ? t.replace(/\{signed\}/g, S.signed)
                 : t.replace(/^\{signed\},\s*/, '').replace(/,\s*\{signed\}(?=[.,!?]|$)/g, '').replace(/\{signed\}/g, 'you');
    t = t.replace(/\{ends\}/g, S.endsAt ? whenWords(S.endsAt) : 'the end of the hold');
    if (!S.name) t = t.replace(/\{name\}'s/g, 'your').replace(/\{name\}/g, 'your hero');
    else if (!keep) t = t.replace(/\{name\}/g, S.name);
    return t.charAt(0).toUpperCase() + t.slice(1);
  }
  /* "Thu, Oct 8 at 9:41pm" in the phone's own time zone */
  function whenParts(ms) {
    var o = {};
    try {
      new Intl.DateTimeFormat('en-US', { weekday: 'short', month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit', hour12: true })
        .formatToParts(new Date(ms)).forEach(function (p) { o[p.type] = p.value; });
    } catch (e) {
      var d = new Date(ms), h = d.getHours();
      o = { weekday: 'Sun Mon Tue Wed Thu Fri Sat'.split(' ')[d.getDay()], month: 'Jan Feb Mar Apr May Jun Jul Aug Sep Oct Nov Dec'.split(' ')[d.getMonth()],
            day: String(d.getDate()), hour: String(h % 12 || 12), minute: ('0' + d.getMinutes()).slice(-2), dayPeriod: h < 12 ? 'AM' : 'PM' };
    }
    return { wd: o.weekday, md: o.month + ' ' + o.day, time: o.hour + ':' + o.minute + String(o.dayPeriod || '').toLowerCase() };
  }
  function whenWords(ms) { var p = whenParts(ms); return p.wd + ', ' + p.md + ' at ' + p.time; }

  /* ---------- the particles (one canvas over the page, only while something is flying) ---------- */
  var FX = (function () {
    var cv = null, ctx = null, W = 0, H = 0, parts = [], raf = 0, lastY = 0;
    function init() {
      if (cv) return true;
      if (RM) return false;
      try {
        cv = document.createElement('canvas'); cv.className = 'ffp-fx'; cv.setAttribute('aria-hidden', 'true');
        root.appendChild(cv); ctx = cv.getContext('2d'); size();
        window.addEventListener('resize', size);
        lastY = window.pageYOffset || 0;
        /* the canvas is pinned to the screen, so a scroll carries every spark with what it came from */
        window.addEventListener('scroll', function () {
          var y = window.pageYOffset || 0, d = y - lastY; lastY = y;
          if (d) for (var i = 0; i < parts.length; i++) parts[i].y -= d;
        }, { passive: true });
      } catch (e) { cv = null; return false; }
      return true;
    }
    function size() {
      var d = Math.min(2, window.devicePixelRatio || 1);
      W = window.innerWidth; H = window.innerHeight;
      cv.width = Math.round(W * d); cv.height = Math.round(H * d); ctx.setTransform(d, 0, 0, d, 0, 0);
    }
    function R(a, b) { return a + Math.random() * (b - a); }
    function pick(a) { return a[(Math.random() * a.length) | 0]; }
    /* Jan, 2026-10-12: "use my brand colors purple: ef94ff blue: b3f5ee". The confetti, and the spark burst that
       scatters from her row at the same moment, are only these two, in equal amounts (every other piece). The gold
       trail of the moving row and the ring where it lands stay gold, like the row itself. */
    var GOLD = ['#fff3cf', '#f4d68a', '#e8c674', '#c9a84c'],
        CONF = ['#ef94ff', '#b3f5ee'];
    function add(p) { p.age = 0; parts.push(p); if (!raf) raf = requestAnimationFrame(tick); }
    function tick() {
      raf = 0;
      ctx.clearRect(0, 0, W, H);
      for (var i = parts.length - 1; i >= 0; i--) {
        var p = parts[i]; p.age++;
        if (p.age >= p.life) { parts.splice(i, 1); continue; }
        p.vx *= p.drag; p.vy = p.vy * p.drag + p.g; p.x += p.vx; p.y += p.vy;
        var k = 1 - p.age / p.life;
        if (p.rect) {
          p.rot += p.vr;
          ctx.save(); ctx.translate(p.x, p.y); ctx.rotate(p.rot);
          ctx.globalAlpha = Math.min(1, k * 1.8); ctx.fillStyle = p.c;
          ctx.fillRect(-p.w / 2, -p.h / 2, p.w, Math.max(1, p.h * Math.abs(Math.cos(p.age * p.flip))));
          ctx.restore();
        } else {
          var r = p.s * (0.45 + k * 0.55);
          ctx.globalAlpha = k * 0.22; ctx.fillStyle = p.c;
          ctx.beginPath(); ctx.arc(p.x, p.y, r * 2.6, 0, 6.2832); ctx.fill();
          ctx.globalAlpha = Math.min(1, k * 1.3);
          ctx.beginPath(); ctx.arc(p.x, p.y, r, 0, 6.2832); ctx.fill();
        }
      }
      ctx.globalAlpha = 1;
      if (parts.length) raf = requestAnimationFrame(tick);
    }
    return {
      rise: function (r) { if (!init()) return; for (var i = 0; i < 4; i++) add({ x: R(r.left + 8, r.right - 8), y: R(r.top + 4, r.bottom - 4), vx: R(-0.3, 0.3), vy: R(-1.6, -0.5), g: -0.012, drag: 0.985, life: R(34, 58), s: R(1.3, 2.6), c: pick(GOLD) }); },
      ring: function (x, y) { if (!init()) return; for (var i = 0; i < 40; i++) { var a = i / 40 * 6.2832, v = R(3.4, 4.2); add({ x: x, y: y, vx: Math.cos(a) * v, vy: Math.sin(a) * v * 0.55, g: 0, drag: 0.915, life: R(30, 40), s: R(1.5, 2.4), c: pick(GOLD) }); } },
      burst: function (x, y) { if (!init()) return; for (var i = 0; i < 28; i++) { var a = R(0, 6.2832), v = R(1, 5.2); add({ x: x, y: y, vx: Math.cos(a) * v, vy: Math.sin(a) * v - 1.2, g: 0.07, drag: 0.955, life: R(40, 66), s: R(1.4, 3), c: CONF[i % 2] }); } },
      confetti: function (x, y, w) { if (!init()) return; for (var i = 0; i < 72; i++) add({ rect: true, x: R(x, x + w), y: R(y - 6, y + 14), vx: R(-2.4, 2.4), vy: R(-7.5, -2.5), g: 0.17, drag: 0.982, life: R(80, 125), w: R(5, 9), h: R(3, 5), rot: R(0, 6.2832), vr: R(-0.22, 0.22), flip: R(0.05, 0.16), c: CONF[i % 2] }); }
    };
  })();
  function mid(el) { var r = el.getBoundingClientRect(); return { x: r.left + r.width / 2, y: r.top + r.height / 2, r: r }; }

  /* ---------- the line ---------- */
  var rowsEl = $('ffp-rows'), nodes = {}, gapEl = null;
  function rowNode(key) {
    var li = nodes[key];
    if (!li) {
      li = document.createElement('li');
      li.setAttribute('data-k', key);
      li.innerHTML = '<span class="ffp-row__p"></span><span class="ffp-row__n"></span>';
      nodes[key] = li;
    }
    return li;
  }
  function paint(li, it) {
    li.className = 'ffp-row' + (it.kind === 'you' ? ' is-you' : '') + (it.kind === 'sk' ? ' ffp-row--sk' : '');
    li.querySelector('.ffp-row__p').textContent = it.p ? '#' + it.p.toLocaleString() : '';
    var n = li.querySelector('.ffp-row__n');
    if (it.kind === 'sk') { n.innerHTML = '<i style="--w:' + it.w + '%"></i>'; }
    else n.textContent = it.n || '';
    if (it.kind === 'you') {
      /* no stamp over the name (Jan, 2026-10-12): the chip says it */
      if (!li.querySelector('.ffp-chip')) {
        var chip = document.createElement('span'); chip.className = 'ffp-chip'; li.appendChild(chip);
      }
      var c = li.querySelector('.ffp-chip');
      c.textContent = it.chip || 'You';
      c.className = 'ffp-chip' + (it.now ? ' is-now' : '');
    } else {
      /* after the skip everybody in the top three is up now, not only them */
      var oc = li.querySelector('.ffp-chip');
      if (it.up) {
        if (!oc) { oc = document.createElement('span'); li.appendChild(oc); }
        oc.className = 'ffp-chip is-now'; oc.textContent = 'Up now';
      } else if (oc) li.removeChild(oc);
    }
  }
  /* "{N} in line" is a button that opens the whole waitlist (Jan, 2026-10-12). The row and its button are made
     once and kept, so the skip's FLIP moves the same node and focus comes back to it when the panel closes. */
  function gapNode() {
    if (!gapEl) {
      gapEl = document.createElement('li'); gapEl.className = 'ffp-gap'; gapEl.setAttribute('data-k', 'gap');
      gapEl.innerHTML = '<button type="button" class="ffp-gap__b" aria-haspopup="dialog" aria-controls="ffp-lb"><span class="ffp-gap__l"></span>' +
        '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 3.5L10.5 8 6 12.5"/></svg></button>';
      var gb = gapEl.querySelector('button');
      gb.addEventListener('click', function () { openLine(gb); });
    }
    return gapEl;
  }
  /* Where everybody stands. P is this person's number: their real one when they hold a spot, the back of the
     line when they are new. The first four names show, then "N in line", then them. Somebody already in
     the first five sits among those names. T is where the skip puts them: #3, or their own place when they are
     already in the top three (in a line of fewer than three, the end of it). */
  var TOP = 3;
  function plan() {
    var list = (S.list || []).filter(function (x) { return x && num(x.p); }).map(function (x) { return { p: num(x.p), n: String(x.n || '') }; })
      .sort(function (a, b) { return a.p - b.p; });
    var P = S.position || (S.total != null ? S.total + 1 : null);
    var ahead = [], behind = [], gap = 0;
    if (P && P <= 5 && list.length) {
      ahead = list.filter(function (x) { return x.p < P; });
      behind = list.filter(function (x) { return x.p > P && x.p <= 5; });
    } else {
      ahead = list.filter(function (x) { return !P || x.p < P; }).slice(0, 4);
      gap = P ? Math.max(0, P - 1 - ahead.length) : -1;
    }
    if (!list.length) {
      ahead = [52, 38, 46, 34].map(function (w, i) { return { p: i + 1, n: '', sk: true, w: w }; });
      if (P && P <= 5) { ahead = ahead.slice(0, P - 1); gap = 0; }
      else gap = P ? Math.max(0, P - 5) : -1;
    }
    return { P: P, T: P ? Math.min(P, TOP) : Math.min(TOP, list.length + 1), ahead: ahead, behind: behind, gap: gap };
  }
  function items(pl, after, you) {
    var out = [];
    /* the panel with the whole line mirrors whichever order this list shows */
    S.after = !!after;
    function person(x, bump) { return { key: x.sk ? 'sk' + x.p : 'p' + x.p, kind: x.sk ? 'sk' : 'row', p: x.p + (bump ? 1 : 0), n: x.n, w: x.w }; }
    var me = { key: 'you', kind: 'you', p: after ? pl.T : pl.P, n: S.name || 'You', chip: you.chip, now: you.now };
    function gap(n) { return { key: 'gap', kind: 'gap', n: n > 0 ? n.toLocaleString() + ' in line' : 'More in line' }; }
    /* Jan, 2026-10-12: "895 in line". Between the names and the player it counts the people between them. At the
       end of the rows (after the skip, or for somebody already in the first five) it counts everybody behind the
       last row shown, the line as the panel it opens counts it (the panel's len), so "384 in line" under #5 opens
       a panel that says "389 in line". */
    var len = S.position ? Math.max(num(S.total) || 0, S.position) : S.total != null ? S.total + 1 : 0;
    var rest = pl.P ? len - 1 - pl.ahead.length - pl.behind.length : -1;
    var tail = rest > 0 || !pl.P ? gap(rest) : null;
    if (after) {
      /* #1 and #2 keep their places, they take #3 (or stay in the top three), the names from the old #3 down step
         back one; once they have landed (now) every row in the top three wears "Up now" */
      var up = function (it) { if (you.now && it.p <= TOP) it.up = true; return it; };
      pl.ahead.forEach(function (x) { if (x.p < pl.T) out.push(up(person(x, false))); });
      out.push(me);
      pl.ahead.forEach(function (x) { if (x.p >= pl.T) out.push(up(person(x, true))); });
      pl.behind.forEach(function (x) { out.push(up(person(x, false))); });
      if (tail) out.push(tail);
    } else {
      pl.ahead.forEach(function (x) { out.push(person(x, false)); });
      if (pl.gap !== 0) out.push(gap(pl.gap));
      out.push(me);
      pl.behind.forEach(function (x) { out.push(person(x, false)); });
      /* somebody already in the first five has no gap before them: the rest of the line comes after the names */
      if (pl.gap === 0 && pl.P && pl.P <= 5 && tail) out.push(tail);
    }
    return out;
  }
  function draw(list) {
    var els = list.map(function (it) {
      if (it.kind === 'gap') {
        var g = gapNode(), gb = g.querySelector('button');
        g.querySelector('.ffp-gap__l').textContent = it.n;
        gb.setAttribute('aria-label', it.n + '. See the whole waitlist.');
        return g;
      }
      var li = rowNode(it.key); paint(li, it); return li;
    });
    Array.prototype.slice.call(rowsEl.children).forEach(function (c) { if (els.indexOf(c) < 0) rowsEl.removeChild(c); });
    els.forEach(function (el) { rowsEl.appendChild(el); });
  }
  var FRESH_WAIT = '1 to 2 months';
  function etaWords(d) {
    if (d <= 1) return '1 day';
    if (d < 14) return d + ' days';
    if (d < 60) return Math.round(d / 7) + ' weeks';
    var m = Math.round(d / 30); return m + (m === 1 ? ' month' : ' months');
  }
  function waitWords() {
    if (S.joined || !S.position) return FRESH_WAIT;
    if (S.eta) return etaWords(S.eta);
    return S.est || FRESH_WAIT;
  }
  function stub(big, small, pop, small2) {
    if ($('ffp-stub')) $('ffp-stub').classList.remove('is-if');
    setText('ffp-stub-n', big); if ($('ffp-stub-n')) $('ffp-stub-n').classList.remove('is-wait');
    var sm = $('ffp-stub') && $('ffp-stub').querySelector('small'); if (sm) sm.textContent = small;
    setText('ffp-stub-t', small2 || '');
    if (pop && !RM) { var s = $('ffp-stub'); s.classList.remove('is-pop'); void s.offsetWidth; s.classList.add('is-pop'); }
  }
  function drawBefore(chip, claiming) {
    var pl = plan();
    draw(items(pl, false, { chip: chip || 'You' }));
    $('ffp-wait').classList.remove('is-done');
    setText('ffp-wait-was', 'about ' + waitWords());
    setText('ffp-wait-sk', S.past ? ', skipped' : '');
    /* an earned pass shows a real place only for somebody in line; anybody else sees where they would stand */
    var ifToday = earned() && !S.inLine && !claiming;
    stub(pl.P ? '#' + pl.P.toLocaleString() : '#1', claiming ? 'If you join' : ifToday ? (C.stub_if || 'If you joined today') : pl.P ? 'Your spot' : 'Yours to claim');
    if (ifToday) $('ffp-stub').classList.add('is-if');
    setText('ffp-say', '');
  }
  function drawAfter(chip) {
    var pl = plan();
    draw(items(pl, true, { chip: chip, now: true }));
    setText('ffp-wait-was', 'about ' + waitWords());
    /* the strike is only drawn, so a screen reader hears that the old wait is gone; nothing changes on screen */
    setText('ffp-wait-sk', ', skipped');
    $('ffp-wait').classList.add('is-done');
    stub(spot(pl), chip === 'Booked' ? 'Booked' : 'Up now');
    /* the panel, if it is open while the skip lands, shows the line the way it now stands, with them in view at #3 */
    if (lbOpen && lineFeed) showLine(lineFeed);
  }
  /* "#3", or their own place when the skip leaves them where they are */
  function spot(pl) { return '#' + (pl || plan()).T.toLocaleString(); }

  /* ---------- the whole waitlist in a panel, from "{N} in line" (Jan, 2026-10-12) ----------
     The names are the waitlist page's own: the Worker's public /queue/state, asked with an empty body so it
     carries no token and no phone. It answers every name in line (899 of 899 on 2026-10-12). It loads on the
     first open and is kept. The viewer stands where the list on this page puts them: their own place before the
     skip, #3 after it (#1 and #2 as they were, everybody from the old #3 to just before them one place back, the
     top three all "Up now"). If the names ever stop short of the
     end of the line, the last rows fade and "N more in line" says the rest. A preview builds sample names and
     asks nothing. */
  var lb = $('ffp-lb'), lbP = $('ffp-lb-p'), lbBody = $('ffp-lb-body'), lbRows = $('ffp-lb-rows'), lbMsg = $('ffp-lb-msg'), lbRetry = $('ffp-lb-retry'),
      lineFeed = null, lineAsk = null, lbOpen = false, lbOpener = null, lbY = 0, lbTimer = 0;
  window.__ffp.line = function () { return { open: lbOpen, feed: lineFeed }; };
  function cleanName(v) { return String(v == null ? '' : v).replace(/[\u0000-\u001f\u007f]/g, '').replace(/\s+/g, ' ').trim().slice(0, 40); }
  function cleanFeed(j) {
    var seen = {}, list = [];
    (Array.isArray(j && j.list) ? j.list : []).forEach(function (x) {
      var p = x && num(x.p); if (!p || seen[p]) return; seen[p] = 1;
      list.push({ p: p, n: cleanName(x.n) });
    });
    list.sort(function (a, b) { return a.p - b.p; });
    return { list: list, total: Math.max(num(j && j.total) || 0, list.length ? list[list.length - 1].p : 0) };
  }
  /* a preview's line: the sample's first names, then made-up ones, as long as the sample's line */
  function sampleFeed() {
    var A = 'Aria Bram Corin Dalia Eamon Fenra Garrick Hollis Isolde Jory Kestrel Lark Mira Nolan Orin Pell Quill Rowan Sable Tamsin Ulric Vesna Wren Yara Zane Ashe Cass Dorian Elra Brielle'.split(' '),
        I = 'ABCDEFGHJKLMNPRSTW', at = {}, list = [], total = num(S.total) || 389;
    (S.list || []).forEach(function (x) { if (x && num(x.p)) at[num(x.p)] = cleanName(x.n); });
    for (var p = 1; p <= total; p++) list.push({ p: p, n: at[p] || A[(p * 7 + 3) % A.length] + (p % 3 ? ' ' + I[(p * 5) % I.length] + '.' : '') });
    return { list: list, total: total };
  }
  function askLine() {
    if (lineFeed) return Promise.resolve(lineFeed);
    if (PREVIEW) { lineFeed = sampleFeed(); return Promise.resolve(lineFeed); }
    if (lineAsk) return lineAsk;
    var ctl = window.AbortController ? new AbortController() : null;
    var t = setTimeout(function () { try { if (ctl) ctl.abort(); } catch (e) {} }, 12000);
    lineAsk = fetch(String(CFG.queueApi || '').replace(/\/+$/, '') + '/queue/state', {
      method: 'POST', headers: { 'Content-Type': 'application/json' }, body: '{}', credentials: 'omit', signal: ctl ? ctl.signal : undefined
    }).then(function (r) { if (!r.ok) throw new Error('state ' + r.status); return r.json(); })
      .then(function (j) { if (!j || j.error || !Array.isArray(j.list)) throw new Error('state'); return cleanFeed(j); })
      .then(function (f) { clearTimeout(t); lineAsk = null; lineFeed = f; return f; },
            function (e) { clearTimeout(t); lineAsk = null; throw e; });
    return lineAsk;
  }
  /* Everybody in the order this page shows them. A viewer who holds a spot is left out of the names at their own
     place and drawn as themselves; anybody else stands at the back. len counts the line as this page shows it. */
  function lineModel(f) {
    var inLine = !!S.position, P = inLine ? S.position : f.total + 1, after = !!S.after;
    var others = f.list.filter(function (x) { return !(inLine && x.p === P); });
    var len = inLine ? Math.max(f.total, P) : f.total + 1;
    var lastFeed = f.list.length ? f.list[f.list.length - 1].p : 0, short = lastFeed < f.total;
    var you = { you: true, n: S.name || 'You' }, rows = [];
    function fade() {
      /* the last three names before a "more in line" fade into it, the last one faintest */
      var at = [];
      for (var i = rows.length - 1; i >= 0 && at.length < 3; i--) { if (rows[i].you || rows[i].note) break; at.push(i); }
      at.forEach(function (idx, j) { rows[idx].f = 3 - j - (3 - at.length); });
    }
    function more(n) { if (n > 0) { fade(); rows.push({ note: n.toLocaleString() + ' more in line' }); } }
    if (after) {
      /* the same order as the page: #1 and #2, then them at #3 (or where they already stood in the top three), then
         the names from the old #3 one place back up to their old place, and everybody after it where they were */
      var T = Math.min(P, TOP);
      others.forEach(function (x) { if (x.p < T) rows.push({ p: x.p, n: x.n, up: true }); });
      you.p = T; rows.push(you);
      others.forEach(function (x) { if (x.p >= T) { var q = inLine && x.p > P ? x.p : x.p + 1; rows.push({ p: q, n: x.n, up: q <= TOP }); } });
      if (short) more(len - rows[rows.length - 1].p);
    } else if (!short || P <= lastFeed) {
      var placed = false;
      others.forEach(function (x) { if (!placed && x.p > P) { you.p = P; rows.push(you); placed = true; } rows.push({ p: x.p, n: x.n }); });
      if (!placed) { you.p = P; rows.push(you); }
      if (short) more(len - rows[rows.length - 1].p);
    } else {
      /* the names stop before the viewer's place: the rest of the line, then the viewer, then anybody after them */
      others.forEach(function (x) { rows.push({ p: x.p, n: x.n }); });
      more(P - 1 - (rows.length ? rows[rows.length - 1].p : 0));
      you.p = P; rows.push(you);
      if (len > P) rows.push({ note: (len - P).toLocaleString() + ' more in line' });
    }
    return { rows: rows, len: len };
  }
  function drawLine(f) {
    var m = lineModel(f), frag = document.createDocumentFragment(), youLi = null;
    var chipEl = nodes.you && nodes.you.querySelector('.ffp-chip');
    m.rows.forEach(function (it) {
      var li = document.createElement('li');
      if (it.note) { li.className = 'ffp-lb__end'; li.textContent = it.note; frag.appendChild(li); return; }
      li.className = 'ffp-row' + (it.you ? ' is-you' : '') + (it.f ? ' is-f' + it.f : '');
      var a = document.createElement('span'), b = document.createElement('span');
      a.className = 'ffp-row__p'; a.textContent = '#' + it.p.toLocaleString();
      b.className = 'ffp-row__n'; b.textContent = it.n || '';
      li.appendChild(a); li.appendChild(b);
      if (it.you) {
        /* the same chip their row on the page wears ("You", "Up now", "Booked") */
        var c = document.createElement('span');
        c.className = 'ffp-chip' + (chipEl && chipEl.classList.contains('is-now') ? ' is-now' : '');
        c.textContent = chipEl ? chipEl.textContent : 'You';
        li.appendChild(c); youLi = li;
      } else if (it.up) {
        /* after the skip the top three are all up now, as on the page */
        var u = document.createElement('span'); u.className = 'ffp-chip is-now'; u.textContent = 'Up now'; li.appendChild(u);
      }
      frag.appendChild(li);
    });
    lbRows.textContent = ''; lbRows.appendChild(frag);
    setText('ffp-lb-n', m.len.toLocaleString() + ' in line');
    return youLi;
  }
  function lbMessage(txt, retry) {
    lbMsg.hidden = !txt;
    setText('ffp-lb-msg-t', txt || '');
    lbRetry.hidden = !retry;
  }
  function showLine(f, keep) {
    lbP.setAttribute('aria-busy', 'false');
    var y = lbBody.scrollTop, youLi = drawLine(f);
    lbMessage(f.list.length ? '' : 'Nobody else is in line right now.', false);
    if (keep) { lbBody.scrollTop = y; return; }
    /* their own row in the middle of the panel, unless it is already in the first screen */
    if (youLi) {
      var top = youLi.offsetTop - (lbBody.clientHeight - youLi.offsetHeight) / 2;
      lbBody.scrollTop = top > 0 ? top : 0;
    }
    /* "Sarah is #3, up now. 389 in line." ("booked" for a pass already bought) */
    var at = S.after && youLi ? youLi.querySelector('.ffp-row__p').textContent : '';
    var yc = at ? youLi.querySelector('.ffp-chip') : null;
    say((at ? (S.name ? S.name + ' is ' : 'You are ') + at + ', ' + (yc && yc.textContent === 'Booked' ? 'booked' : 'up now') + '. ' : '') + $('ffp-lb-n').textContent + '.');
  }
  function lbLoad() {
    lbP.setAttribute('aria-busy', 'true');
    lbMessage('', false);
    var sk = '';
    for (var i = 0; i < 9; i++) sk += '<li class="ffp-row ffp-row--sk"><span class="ffp-row__p"></span><span class="ffp-row__n"><i style="--w:' + [52, 38, 46, 34, 44, 30, 50, 36, 42][i] + '%"></i></span></li>';
    lbRows.innerHTML = sk;
    setText('ffp-lb-n', 'Loading the line…');
    askLine().then(function (f) { if (lbOpen) showLine(f); }, function () {
      if (!lbOpen) return;
      lbP.setAttribute('aria-busy', 'false');
      lbRows.textContent = '';
      setText('ffp-lb-n', '');
      lbMessage("The line didn't load.", true);
      try { lbRetry.focus({ preventScroll: true }); } catch (e) {}
    });
  }
  /* page scroll stays put under the panel, iPhone in-app browsers included: the body is pinned where it was */
  function lockPage(on) {
    var b = document.body, h = document.documentElement;
    if (on) {
      lbY = window.pageYOffset || 0;
      b.style.position = 'fixed'; b.style.top = -lbY + 'px'; b.style.left = '0'; b.style.right = '0'; b.style.width = '100%';
      h.style.overflow = 'hidden';
      return;
    }
    b.style.position = ''; b.style.top = ''; b.style.left = ''; b.style.right = ''; b.style.width = '';
    h.style.overflow = '';
    var sb = h.style.scrollBehavior; h.style.scrollBehavior = 'auto';
    window.scrollTo(0, lbY);
    h.style.scrollBehavior = sb;
  }
  function lbInert(on) {
    [root.querySelector('.ffp-main'), $('ffp-sticky'), root.querySelector('.ffp-preview')].forEach(function (el) {
      if (!el) return;
      if (on) el.setAttribute('inert', ''); else el.removeAttribute('inert');
    });
  }
  function openLine(from) {
    if (lbOpen) return;
    lbOpen = true; lbOpener = from || null;
    clearTimeout(lbTimer);
    lockPage(true); lbInert(true);
    lb.hidden = false;
    lbBody.scrollTop = 0;
    if (lineFeed) showLine(lineFeed); else lbLoad();
    if (RM) lb.classList.add('is-open');
    else requestAnimationFrame(function () { requestAnimationFrame(function () { if (lbOpen) lb.classList.add('is-open'); }); });
    try { $('ffp-lb-x').focus({ preventScroll: true }); } catch (e) {}
    document.addEventListener('keydown', onLbKey, true);
  }
  function closeLine() {
    if (!lbOpen) return;
    lbOpen = false;
    document.removeEventListener('keydown', onLbKey, true);
    lb.classList.remove('is-open');
    if (RM) lb.hidden = true; else lbTimer = setTimeout(function () { lb.hidden = true; }, 300);
    lbInert(false); lockPage(false);
    if (lbOpener && document.documentElement.contains(lbOpener)) { try { lbOpener.focus({ preventScroll: true }); } catch (e) {} }
    stickyLater();
    /* the skip landed while the panel was open: the sizes come up now, as the panel fades */
    if (sizesUpLater) setTimeout(sizesUp, RM ? 0 : 200);
  }
  function onLbKey(e) {
    if (e.key === 'Escape' || e.key === 'Esc') { e.preventDefault(); closeLine(); return; }
    if (e.key !== 'Tab') return;
    /* focus stays in the panel */
    var f = [$('ffp-lb-x'), lbBody];
    if (!lbMsg.hidden && !lbRetry.hidden) f.push(lbRetry);
    var i = f.indexOf(document.activeElement);
    if (e.shiftKey ? i <= 0 : (i < 0 || i === f.length - 1)) { e.preventDefault(); f[e.shiftKey ? f.length - 1 : 0].focus(); }
  }
  $('ffp-lb-x').addEventListener('click', closeLine);
  $('ffp-lb-bg').addEventListener('click', closeLine);
  lbRetry.addEventListener('click', function () { if (lbOpen) lbLoad(); });

  /* ---------- the skip ---------- */
  var timers = [], played = false;
  function later(f, ms) { timers.push(setTimeout(f, ms)); }
  /* A link opened in a background tab waits until somebody looks. Coming back to the tab starts it, and so does
     the first tap or scroll, in case a browser keeps reporting the page as hidden. */
  var waiting = false;
  function play() {
    if (played) return;
    if (document.hidden && !waiting) {
      waiting = true;
      var go = function (fromVisibility) {
        if (fromVisibility && document.hidden) return;
        document.removeEventListener('visibilitychange', onVis);
        window.removeEventListener('pointerdown', onTap, true);
        window.removeEventListener('scroll', onTap, true);
        waiting = false; playNow();
      };
      var onVis = function () { go(true); }, onTap = function () { go(false); };
      document.addEventListener('visibilitychange', onVis);
      window.addEventListener('pointerdown', onTap, true);
      window.addEventListener('scroll', onTap, { capture: true, passive: true });
      return;
    }
    if (waiting) return;
    playNow();
  }
  function playNow() {
    if (played) return;
    played = true;
    window.__ffp.playedAt = performance.now();
    S.y0 = window.pageYOffset || 0;
    track('skip_played', { ff_fast_pass_joined: S.joined });
    if (RM) { land(true); return; }
    /* Jan, 2026-10-12: no stamp lands on the row any more. The lift and the hop keep their timing. */
    later(function () { if (nodes.you) nodes.you.classList.add('is-lift'); }, 1350);
    later(flight, 1650);
  }
  function flight() {
    var pl = plan(), you = nodes.you;
    if (!you) return land(false);
    /* already in the top three: they stay where they are and land there */
    if (!pl.P || pl.P <= TOP) return land(false);
    var els = Array.prototype.slice.call(rowsEl.children), first = els.map(function (el) { return el.getBoundingClientRect().top; });
    /* each number changes as its row moves, not before */
    var oldNum = els.map(function (el) { var n = el.querySelector('.ffp-row__p'); return n ? n.textContent : null; });
    var gapL = gapEl && gapEl.parentNode === rowsEl ? gapEl.querySelector('.ffp-gap__l') : null, gapOld = gapL ? gapL.textContent : null;
    draw(items(pl, true, { chip: 'You' }));
    you.classList.add('is-lift');
    var moved = 0;
    els.forEach(function (el, i) {
      var dy = first[i] - el.getBoundingClientRect().top, numEl = el.querySelector('.ffp-row__p');
      /* "209 in line" becomes everybody behind #5 as its row moves down */
      if (el === gapEl && gapL && gapL.textContent !== gapOld) {
        var gapNew = gapL.textContent; gapL.textContent = gapOld;
        setTimeout(function () { gapL.textContent = gapNew; }, 240 + moved * 55 + 220);
      }
      if (el !== you && numEl && oldNum[i] != null) {
        var fresh = numEl.textContent; numEl.textContent = oldNum[i];
        var at = 240 + moved * 55;
        if (!dy) { numEl.textContent = fresh; return; }
        setTimeout(function () { numEl.textContent = fresh; el.classList.add('is-bumped'); }, at + 220);
      }
      if (!dy || !el.animate) return;
      try {
        if (el === you) {
          el.animate([{ transform: 'translateY(' + dy + 'px) scale(1.035)' },
                      { transform: 'translate(-6px,' + (dy * 0.42) + 'px) scale(1.07)', offset: 0.55 },
                      { transform: 'translateY(0) scale(1)' }],
                     { duration: 980, easing: 'cubic-bezier(.55,.05,.35,1)' });
        } else {
          var delay = 240 + (moved++) * 55;
          el.animate([{ transform: 'translateY(' + dy + 'px)' }, { transform: 'translateY(0)' }],
                     { duration: 620, delay: delay, easing: 'cubic-bezier(.2,.8,.2,1)', fill: 'backwards' });
        }
      } catch (e) {}
    });
    countDown(pl.P, pl.T, 960);
    var n = 0, iv = setInterval(function () { if (nodes.you) FX.rise(nodes.you.getBoundingClientRect()); if (++n > 12) clearInterval(iv); }, 75);
    timers.push(iv);
    later(function () { land(false); }, 1000);
  }
  /* Their number rolls down to #3 as the row flies, on the row and on the ticket's stub. */
  function countDown(from, to, ms) {
    var you = nodes.you, a = you && you.querySelector('.ffp-row__p'), b = $('ffp-stub-n');
    if (!from || from <= to) return;
    var t0 = 0;
    function put(v) { var t = '#' + v.toLocaleString(); if (a) a.textContent = t; if (b) { b.textContent = t; b.classList.remove('is-wait'); } }
    put(from);
    function step(ts) {
      if (!t0) t0 = ts;
      var k = Math.min(1, (ts - t0) / ms), e = k < 0.5 ? 4 * k * k * k : 1 - Math.pow(-2 * k + 2, 3) / 2;
      put(Math.max(to, Math.round(from - (from - to) * e)));
      if (k < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }
  function land(still) {
    var pass = $('ffp-pass');
    window.__ffp.landedAt = performance.now();
    drawAfter('Up now');
    var you = nodes.you, at = spot();
    if (you) { you.classList.remove('is-lift'); if (!still) you.classList.add('is-landed'); }
    var done = fill(C.say_done || '{name} is up now.', S.name);
    setText('ffp-say', done);
    /* a screen reader also hears the place: "Sarah is up now. #3 in line. Pick your portrait size." */
    say(done + ' ' + at + ' in line. ' + ($('ffp-offer-h') ? $('ffp-offer-h').textContent : ''));
    if (!still) {
      stub(at, 'Up now', true);
      pass.classList.add('is-glow');
      if (you) { var m = mid(you); FX.ring(m.x, m.y); FX.burst(m.x, m.y); }
      /* the confetti rises from the row they landed on, across the pass, and falls over the top three */
      var pr = pass.getBoundingClientRect(), top = you ? m.r.top : pr.top;
      FX.confetti(pr.left + 10, Math.max(0, top - 6), pr.width - 20);
      buzz([16, 40, 26]);
    }
    setTimeout(reveal, still ? 0 : 560);
  }
  var revealed = false;
  function reveal() {
    if (revealed) return; revealed = true;
    var offer = $('ffp-offer'), after = $('ffp-after');
    offer.hidden = false; after.hidden = false;
    if (RM) { offer.classList.remove('is-pre'); after.classList.remove('is-pre'); }
    else requestAnimationFrame(function () { requestAnimationFrame(function () { offer.classList.remove('is-pre'); after.classList.remove('is-pre'); }); });
    track('offer_shown');
    loadReviews();
    stickyLater();
    setTimeout(sizesUp, RM ? 0 : 380);
  }
  /* bring the sizes up, unless they already moved the page themselves. While the whole waitlist is open the page
     is pinned and cannot move, so this waits and runs when the panel closes. */
  var sizesUpLater = false;
  function sizesUp() {
    if (lbOpen) { sizesUpLater = true; return; }
    sizesUpLater = false;
    if (Math.abs((window.pageYOffset || 0) - S.y0) > 40) return;
    var offer = $('ffp-offer'), r = offer.getBoundingClientRect(), vh = window.innerHeight || 700;
    if (r.top < vh * 0.6) return;
    var to = (window.pageYOffset || 0) + r.top - vh * 0.3;
    try { window.scrollTo({ top: to, behavior: RM ? 'auto' : 'smooth' }); } catch (e) { window.scrollTo(0, to); }
  }

  /* ---------- the stages ---------- */
  var claimForm = $('ffp-claim'), notYou = $('ffp-notyou');
  /* stages with no pass card: Jan turned it off, an earned pass ended, a code that matches nothing, or a pass
     that did not load */
  var NO_CARD = { off: 1, ended: 1, missing: 1, retry: 1 };
  function show(stage) {
    S.stage = stage; root.setAttribute('data-stage', stage);
    /* the phone buy bar only while the pass is open for buying; it checks again on the next frame */
    stickyLater();
    var nm = S.name, pass = $('ffp-pass'), E = earned();
    /* an earned ticket shows no photo and no seal (the player signed it); its stamp in the line drops Jan's name */
    root.setAttribute('data-kind', E ? 'earned' : 'jan');
    setText('ffp-for', nm || 'you');
    setText('ffp-from', E && S.signed ? 'Signed, ' + S.signed : 'From Jan');
    setText('ffp-thanks-t', fill(C.thanks, nm));
    var note = $('ffp-note');
    if (note) {
      if (E && S.endsAt && String(C.note_earned || '').indexOf('{ends}') >= 0) {
        /* Jan, 2026-10-12: the expiry date in bold gold, so the player sees at a glance when the skip ends. Built as
           nodes (text, <b>date</b>, text) so nothing the player typed is ever read as markup. */
        var bits = String(C.note_earned).split('{ends}');
        note.textContent = '';
        bits.forEach(function (b, i) {
          if (i) { var w = document.createElement('b'); w.className = 'ffp-note__when'; w.textContent = whenWords(S.endsAt); note.appendChild(w); }
          if (b) note.appendChild(document.createTextNode(fillE(b)));
        });
      } else note.textContent = E ? fillE(C.note_earned) : fill(C.note, nm);
    }
    if (stage !== 'soon') stopSoon();
    pass.hidden = !!NO_CARD[stage];
    var tl = $('ffp-tolist'); if (tl && !/^(off|ended|missing)$/.test(stage)) tl.parentNode.removeChild(tl);
    var rb = $('ffp-retry'); if (rb && stage !== 'retry') rb.parentNode.removeChild(rb);
    if (stage === 'claim') {
      setRich($('ffp-h1'), C.h1_claim, nm, true);
      setRich($('ffp-lede'), claimLede(), nm, true);
      notYou.hidden = true;
      openClaim();
      drawBefore('You', true);
      return;
    }
    closeClaim();
    if (stage === 'soon') {
      setRich($('ffp-h1'), nb(fillE(C.h1_soon, true)), nm, true);
      setRich($('ffp-lede'), fillE(C.lede_soon), '', true);
      notYou.hidden = true;
      drawSoon();
      startSoon();
      if (!soonTracked) { soonTracked = true; track('soon_shown', { ff_fast_pass_kind: 'earned' }); }
      return;
    }
    if (stage === 'line') {
      setRich($('ffp-h1'), E ? nb(fillE(C.h1_earned, true)) : C.h1_line, nm, true);
      if (E) setRich($('ffp-lede'), heldWords(), '', true);
      else setRich($('ffp-lede'), C.lede_line, nm, true);
      notYou.textContent = nm ? 'Not ' + nm + '?' : 'Not you?';
      notYou.hidden = !nm || E;
      drawBefore('You');
      /* the size they picked in the portal is already chosen */
      if (E && S.pick) { var pb = sizeBtns.filter(function (b) { return b.getAttribute('data-size') === S.pick; })[0]; if (pb) pickSize(pb); }
      setTimeout(play, RM ? 0 : 350);
      return;
    }
    notYou.hidden = true;
    if (stage === 'bought') {
      /* an earned pass greets the player who signed it, not the hero it is made out to */
      setRich($('ffp-h1'), C.h1_bought, E ? (S.signed || '') : nm, true);
      setRich($('ffp-lede'), C.lede_bought, nm, true);
      drawAfter('Booked');
      setText('ffp-say', S.order ? 'Order ' + S.order + ' is booked.' : 'Your spot is booked.');
      if (!$('ffp-again')) {
        var b = document.createElement('button');
        b.type = 'button'; b.id = 'ffp-again'; b.className = 'ffp-btn ffp-btn--ghost'; b.textContent = 'Order another portrait';
        b.style.marginBottom = '20px';
        b.addEventListener('click', function () { b.remove(); reveal(); });
        pass.parentNode.insertBefore(b, pass.nextSibling);
      }
      return;
    }
    if (stage === 'off') {
      setRich($('ffp-h1'), C.h1_off, nm, true);
      setRich($('ffp-lede'), C.lede_off, nm, true);
      toList();
      return;
    }
    if (stage === 'ended') {
      setRich($('ffp-h1'), nb(fillE(C.h1_ended, true)), nm, true);
      setRich($('ffp-lede'), fillE(S.hasLine ? C.lede_ended_line : C.lede_ended), '', true);
      toList();
      if (!endTracked) { endTracked = true; track('ended_shown', { ff_fast_pass_kind: 'earned' }); }
      return;
    }
    if (stage === 'missing') {
      setRich($('ffp-h1'), C.h1_missing, '', true);
      setRich($('ffp-lede'), C.lede_missing, '', true);
      toList();
      return;
    }
    if (stage === 'retry') {
      setRich($('ffp-h1'), C.h1_retry, '', true);
      setRich($('ffp-lede'), C.lede_retry, '', true);
      var b2 = $('ffp-retry');
      if (!b2) {
        b2 = document.createElement('button');
        b2.type = 'button'; b2.id = 'ffp-retry'; b2.className = 'ffp-btn';
        b2.addEventListener('click', function () { b2.disabled = true; b2.textContent = 'Opening…'; boot(); });
        pass.parentNode.insertBefore(b2, pass);
      }
      b2.disabled = false; b2.textContent = C.retry || 'Try again';
    }
  }
  function toList() {
    var pass = $('ffp-pass');
    if ($('ffp-tolist')) return;
    var a = document.createElement('a');
    a.id = 'ffp-tolist'; a.className = 'ffp-btn'; a.href = CFG.waitlistUrl || '/pages/waitlist'; a.textContent = 'See the waitlist';
    pass.parentNode.insertBefore(a, pass);
  }
  /* "Expires Sat, Oct 10 at 9:41am your time." and, for somebody also in line, that the hero keeps it */
  function heldWords() {
    var t = S.endsAt ? fillE(C.lede_earned) : '';
    if (S.hasLine) t = (t ? t + ' ' : '') + fillE(C.lede_earned_line);
    return t;
  }

  /* ---------- an earned pass before it opens: the countdown, then the server is asked again ---------- */
  var soonIv = 0, soonBusy = false, soonNext = 0, soonWait = 2000, soonTracked = false, endTracked = false;
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function drawSoon() {
    if (!S.opensAt) return;
    var p = whenParts(S.opensAt);
    stub(p.wd, p.md, false, p.time);
    setText('ffp-opens', whenWords(S.opensAt) + ' your time');
    // the expiry, said once on this page (Jan: "Expires", never "Held")
    var fine = $('ffp-soon-fine'); if (fine) fine.textContent = fillE(fine.getAttribute('data-tpl'));
    var cal = $('ffp-cal'); if (cal) cal.href = calHref();
    say(fillE(C.h1_soon) + ' ' + whenWords(S.opensAt) + ' your time.');
    drawPlan();
    tickSoon();
  }

  /* ---------- before it opens: Jan's plan for the hero (no way to buy until it opens: the wait is the point) ---------- */
  /* The picks come from the server (the player's saved picks, else the blueprint's). Every value is text. */
  function cleanPlan(p) {
    if (!p || typeof p !== 'object') return null;
    function c(v) { return String(v == null ? '' : v).replace(/[\u0000-\u001f\u007f]/g, ' ').replace(/\s+/g, ' ').trim().slice(0, 80); }
    var o = { pose: c(p.pose), vibe: c(p.vibe), bg: c(p.bg) };
    return o.pose || o.vibe || o.bg ? o : null;
  }
  function sizeOf(id) {
    var b = sizeBtns.filter(function (x) { return x.getAttribute('data-size') === id; })[0];
    return b ? { id: id, variant: b.getAttribute('data-variant'), label: b.getAttribute('data-label'), price: b.getAttribute('data-price') } : null;
  }
  var planKey = '';
  function drawPlan() {
    var card = $('ffp-plan'), list = $('ffp-plan-list');
    if (!card || !list) return;
    var size = sizeOf(S.pick), rows = [];
    // A pick the blueprint left empty is saved as "Left blank" (earlier as "Jan's pick"): no row for it.
    var picked = function (v) { return v && !/^(left blank|jan[’']s pick)$/i.test(String(v).trim()); };
    if (S.plan) {
      if (picked(S.plan.pose)) rows.push([C.plan_pose || 'Pose', S.plan.pose]);
      if (picked(S.plan.vibe)) rows.push([C.plan_vibe || 'Mood', S.plan.vibe]);
      if (picked(S.plan.bg)) rows.push([C.plan_bg || 'Background', S.plan.bg]);
    }
    if (size) rows.push([C.plan_size || 'Size', size.label, size.price]);
    var key = JSON.stringify([S.name, rows]);
    if (key !== planKey) {
      planKey = key;
      list.textContent = '';
      rows.forEach(function (r) {
        var d = document.createElement('div'), dt = document.createElement('dt'), dd = document.createElement('dd');
        d.className = 'ffp-plan__row'; dt.textContent = r[0]; dd.textContent = r[1];
        if (r[2]) { var sm = document.createElement('small'); sm.textContent = r[2]; dd.appendChild(sm); }
        d.appendChild(dt); d.appendChild(dd); list.appendChild(d);
      });
      setRich($('ffp-plan-h'), fillE(C.plan_heading || "Jan's plan for {name}", true), S.name, false);
      setText('ffp-plan-fine', fillE(C.plan_fine || ''));
    }
    card.hidden = !rows.length;
  }
  function tickSoon() {
    if (S.stage !== 'soon' || !S.opensAt) return;
    var left = S.opensAt - serverNow(), el = $('ffp-count');
    if (left > 0) {
      /* Earned passes open about a week after the send since QUEST-SKIP-06 (Jan, 2026-10-15): days lead once a day or more is left. */
      var s = Math.ceil(left / 1000), dd = Math.floor(s / 86400), txt = (dd ? dd + 'd ' : '') + pad(Math.floor(s % 86400 / 3600)) + ':' + pad(Math.floor(s % 3600 / 60)) + ':' + pad(s % 60);
      if (el && el.textContent !== txt) { el.textContent = txt; el.classList.toggle('is-days', !!dd); }
      setText('ffp-soon-k', C.soon_label || 'Opens in');
      return;
    }
    if (el) el.textContent = '00:00:00';
    setText('ffp-soon-k', C.soon_opening || 'Opening now');
    askAgain();
  }
  /* At the opening time the server decides. If it still says soon (a clock a little behind), it is asked again
     after 2, 4, 8 ... up to 60 seconds. */
  function askAgain() {
    if (PREVIEW || soonBusy || Date.now() < soonNext || !S.code) return;
    soonBusy = true;
    askedCode = S.code;
    rpc('fastpass_open', { p_code: S.code, p_token: null }, 12000).then(function (r) {
      soonBusy = false;
      if (r && r.kind === 'earned' && r.stage === 'soon') later2();
      apply(r);
    }, function () { soonBusy = false; later2(); });
  }
  function later2() { soonNext = Date.now() + soonWait; soonWait = Math.min(60000, soonWait * 2); }
  function onSoonVis() { if (!document.hidden) tickSoon(); }
  function startSoon() {
    if (soonIv) return;
    soonIv = setInterval(tickSoon, 500);
    document.addEventListener('visibilitychange', onSoonVis);
  }
  function stopSoon() {
    if (soonIv) { clearInterval(soonIv); soonIv = 0; }
    document.removeEventListener('visibilitychange', onSoonVis);
    soonWait = 2000; soonNext = 0;
  }
  /* Google Calendar, at the opening time. The pass code stays out of this link: a tapped link's address can
     reach the store's trackers. The event names the page, and the email carries the personal link. */
  function calHref() {
    function z(ms) { return new Date(ms).toISOString().replace(/[-:]/g, '').replace(/\.\d+/, ''); }
    var page = window.location.origin + window.location.pathname;
    return 'https://calendar.google.com/calendar/render?action=TEMPLATE' +
      '&text=' + encodeURIComponent(fillE(C.cal_title)) +
      '&dates=' + z(S.opensAt) + '/' + z(S.opensAt + 30 * 60000) +
      '&details=' + encodeURIComponent(fillE(C.cal_details) + '\n\n' + page);
  }

  function remember(r) {
    if (r.code) { S.code = r.code; writeJSON(PASS_KEY, { code: r.code, at: Date.now() }); }
    if (r.kind) S.kind = r.kind;
    if (r.name) S.name = nice(r.name);
    S.token = UUID.test(r.token || '') ? r.token : null;
    S.state = r.state || null;
    S.position = num(r.position);
    if (r.total != null) S.total = num(r.total) || 0;
    if (Array.isArray(r.list)) S.list = r.list;
    /* the hub's estimate may already say "about" (live: "about 2 weeks"); the wait line adds its own */
    S.est = typeof r.est_wait === 'string' && r.est_wait.trim() ? r.est_wait.trim().replace(/^about\s+/i, '') : S.est;
    S.eta = num(r.eta_days);
    S.order = r.order || null;
    /* an earned pass: made out to the hero, signed by the player, open between two times on the server's clock */
    var E = r.kind === 'earned';
    if (E && r.hero_name) S.name = nice(r.hero_name);
    S.signed = E ? nice(r.signed) : '';
    S.opensAt = E ? when(r.opens_at) : null;
    S.endsAt = E ? when(r.ends_at) : null;
    var now = E ? when(r.now) : null;
    S.offset = now ? now - Date.now() : 0;
    S.hasLine = E && r.has_line === true;
    /* an earned pass gives a real place only when the player is in line (in_line); otherwise the skip starts
       from the back of the line, where they would stand if they joined today */
    S.inLine = E && r.in_line === true && S.position != null;
    if (E && !S.inLine) S.position = null;
    S.plan = E ? cleanPlan(r.plan) : null;
    S.pick = E && /^(half|thigh|full)$/.test(r.size || '') ? r.size : null;
    S.questSession = E ? sessionId(r.quest_session) : null;
    S.heroId = E && UUID.test(r.hero_id || '') ? r.hero_id : null;
    /* A phone that never held a spot learns this one, like the waitlist page's own join. */
    if (S.token && !PREVIEW) {
      var live = readJSON(LIVE_KEY) || {};
      if (!live.token) { live.token = S.token; live.name = S.name; writeJSON(LIVE_KEY, live); }
    }
  }
  var EARNED_STAGES = { soon: 1, line: 1, ended: 1, bought: 1, off: 1 };
  var askedCode = null, priorPass = null;
  /* A code that matched nothing is not kept on this phone; whatever pass was saved before comes back. */
  function forget(code) {
    if (!code || PREVIEW) return;
    var cur = readJSON(PASS_KEY);
    if (!cur || cur.code !== code) return;
    if (priorPass && priorPass.code && priorPass.code !== code) writeJSON(PASS_KEY, priorPass);
    else { try { localStorage.removeItem(PASS_KEY); } catch (e) {} }
  }
  function apply(r) {
    var asked = askedCode;
    if (r && r.error === 'not_found' && !r.code) forget(asked);
    if (!r || r.ok === false) { show(isEarnedCode(asked) ? (r && r.error === 'not_found' ? 'missing' : 'retry') : 'claim'); return; }
    /* an earned link the database does not know never falls back to the phone form */
    if (r.kind !== 'earned' && r.stage === 'phone' && isEarnedCode(asked)) { show(earned() ? 'retry' : 'missing'); return; }
    remember(r);
    if (earned()) {
      var st = EARNED_STAGES[r.stage] ? r.stage : guessStage();
      if (st === 'soon' && S.stage === 'soon') { drawSoon(); return; }
      show(st);
      return;
    }
    show(r.stage === 'line' ? 'line' : r.stage === 'bought' ? 'bought' : r.stage === 'off' ? 'off' : 'claim');
  }
  /* a stage this page does not know yet, for an earned pass: read its times, never the phone form */
  function guessStage() {
    var n = serverNow();
    if (S.opensAt && n < S.opensAt) return 'soon';
    if (S.endsAt && n >= S.endsAt) return 'ended';
    return 'retry';
  }

  /* ---------- the claim form ---------- */
  var claimBusy = false, joinP = null;
  function openClaim() {
    claimForm.hidden = false; claimForm.classList.remove('is-out'); claimForm.style.height = '';
    var f = $('ffp-first'); if (f && !f.value && S.name) f.value = S.name;
    ensurePhoneUtils(); initPhoneInput($('ffp-phone'));
  }
  function closeClaim() {
    if (claimForm.hidden) return;
    if (RM) { claimForm.hidden = true; return; }
    var h = claimForm.offsetHeight;
    claimForm.style.height = h + 'px'; claimForm.style.transition = 'height .32s cubic-bezier(.2,.7,.2,1), opacity .22s, transform .22s, margin .32s';
    requestAnimationFrame(function () { claimForm.classList.add('is-out'); claimForm.style.height = '0px'; claimForm.style.marginBottom = '0px'; claimForm.style.paddingTop = '0px'; claimForm.style.paddingBottom = '0px'; claimForm.style.borderWidth = '0px'; });
    setTimeout(function () { claimForm.hidden = true; claimForm.removeAttribute('style'); claimForm.classList.remove('is-out'); }, 360);
  }
  function claimErr(msg) { var e = $('ffp-claim-err'); e.textContent = msg || ''; }
  function setClaimBusy(on, label) {
    claimBusy = on;
    var b = $('ffp-claim-btn'); b.disabled = on;
    var l = b.querySelector('.ffp-btn__l');
    if (!l.getAttribute('data-l')) l.setAttribute('data-l', l.textContent);
    l.textContent = on ? (label || 'Finding your spot…') : l.getAttribute('data-l');
  }
  claimForm.addEventListener('submit', function (e) {
    e.preventDefault();
    if (claimBusy) return;
    claimErr('');
    var first = nice($('ffp-first').value);
    if (!first) { claimErr('Add your first name.'); $('ffp-first').focus(); return; }
    withPhone($('ffp-phone'), function (ph) {
      if (ph.error) { claimErr(ph.error); return; }
      setClaimBusy(true);
      S.name = first;
      if (PREVIEW) { setTimeout(function () { setClaimBusy(false); S.joined = true; S.position = (S.total || 0) + 1; show('line'); }, 500); return; }
      rpc('fastpass_claim', { p_code: S.code, p_phone: ph.number }, 12000).then(function (r) {
        setClaimBusy(false);
        if (r && r.ok && (r.stage === 'line' || r.stage === 'bought' || r.stage === 'off')) {
          try { if (!localStorage.getItem(PRIOR_KEY)) localStorage.setItem(PRIOR_KEY, 'first'); } catch (x) {}
          pixel('trackCustom', 'FastPassClaimed', { joined: false });
          track('claimed', { ff_fast_pass_joined: false });
          apply(r);
        } else if (r && r.ok && r.stage === 'join') {
          /* not in line yet: the skip plays from the back of the line while the Worker signs them up */
          if (r.code) S.code = r.code;
          if (r.total != null) S.total = num(r.total) || 0;
          if (Array.isArray(r.list)) S.list = r.list;
          if (typeof r.est_wait === 'string') S.est = r.est_wait.trim().replace(/^about\s+/i, '');
          S.position = (S.total || 0) + 1; S.token = null; S.joined = true; S.eta = null;
          joinInBackground(first, ph.number);
          pixel('trackCustom', 'FastPassClaimed', { joined: true });
          track('claimed', { ff_fast_pass_joined: true });
          show('line');
        } else if (r && r.error === 'phone') {
          claimErr("That number doesn't look right.");
        } else {
          claimErr("Something blocked that. Try again, or reply to Jan's message and Jan will open your spot.");
        }
      }, function () {
        setClaimBusy(false);
        claimErr('That didn\'t go through. Check your signal and try again.');
      });
    });
  });
  function joinInBackground(first, phone) {
    function attempt() {
      return workerJoin(first, phone).then(function (j) {
        if (!j || !j.you || !UUID.test(j.you.token || '')) throw new Error('join');
        S.token = j.you.token;
        var live = readJSON(LIVE_KEY) || {};
        live.token = j.you.token; live.name = first; live.phone = phone;
        if (!j.total || (j.you.position || 0) >= j.total - 2) live.joinedAt = Date.now();
        writeJSON(LIVE_KEY, live);
        try { localStorage.setItem(PRIOR_KEY, localStorage.getItem(PRIOR_KEY) ? 'again' : 'first'); } catch (x) {}
        return rpc('fastpass_claim', { p_code: S.code, p_token: S.token }, 12000).then(function (r) {
          if (r && r.ok && r.code) { S.code = r.code; writeJSON(PASS_KEY, { code: r.code, at: Date.now() }); }
          return S.token;
        }, function () { return S.token; });
      });
    }
    joinP = attempt().catch(function () { return wait(1500).then(attempt); }).catch(function () { return null; });
    return joinP;
  }
  notYou.addEventListener('click', function () {
    S.code = null; S.name = ''; S.token = null; S.position = null; S.joined = false; played = false; revealed = false;
    setPast(false);
    timers.forEach(function (t) { clearTimeout(t); clearInterval(t); }); timers = [];
    try { localStorage.removeItem(PASS_KEY); } catch (e) {}
    $('ffp-offer').hidden = true; $('ffp-offer').classList.add('is-pre');
    $('ffp-after').hidden = true; $('ffp-after').classList.add('is-pre');
    $('ffp-first').value = '';
    stickyLater();
    show('claim');
    try { $('ffp-first').focus({ preventScroll: false }); } catch (e) {}
  });

  /* ---------- phone numbers: the waitlist page's own checks (intl-tel-input, the same countries) ---------- */
  var SMS_COUNTRIES = ['us', 'ca', 'gb', 'au', 'nz', 'at', 'be', 'dk', 'fi', 'fr', 'de', 'hu', 'ie', 'it', 'lu', 'nl', 'no', 'pl', 'pt', 'es', 'se', 'ch'];
  var SMS_MAP = {}; SMS_COUNTRIES.forEach(function (c) { SMS_MAP[c] = true; });
  var phoneUtilsPromise = null;
  function ensurePhoneUtils() {
    if (window.intlTelInput && window.intlTelInput.utils) phoneUtilsPromise = Promise.resolve(true);
    else if (window.ffqPhoneUtilsPromise) phoneUtilsPromise = window.ffqPhoneUtilsPromise;
    else if (window.intlTelInput && window.intlTelInput.attachUtils && CFG.phoneUtils) {
      try { window.ffqPhoneUtilsPromise = window.intlTelInput.attachUtils(function () { return import(CFG.phoneUtils); }); } catch (e) {}
      phoneUtilsPromise = window.ffqPhoneUtilsPromise;
    }
    return phoneUtilsPromise;
  }
  function initPhoneInput(input) {
    if (!input || input._ffpIti || !window.intlTelInput) return input && input._ffpIti;
    try {
      input._ffpIti = window.intlTelInput(input, {
        initialCountry: 'us', onlyCountries: SMS_COUNTRIES, countryOrder: ['us', 'ca', 'gb', 'au', 'nz'], countrySelectorMode: 'AUTO',
        dropdownParent: document.body, separateDialCode: true, showFlags: true, formatAsYouType: true, strictMode: true,
        strictRejectAnimation: true, placeholderNumberPolicy: 'AGGRESSIVE', placeholderNumberType: 'MOBILE',
        allowedNumberTypes: ['MOBILE', 'FIXED_LINE_OR_MOBILE', 'VOIP']
      });
      input.addEventListener('input', function () { claimErr(''); });
    } catch (e) { input._ffpIti = null; }
    return input._ffpIti;
  }
  function fallbackPhone(input) {
    var raw = String((input && input.value) || '').trim().replace(/[\s().-]/g, '');
    if (/^\+[1-9]\d{6,14}$/.test(raw)) return { number: raw };
    var d = raw.replace(/\D/g, '');
    var c = input && input._ffpIti ? input._ffpIti.getSelectedCountry() : { iso2: 'us' };
    if (!c || c.iso2 === 'us' || c.iso2 === 'ca') {
      if (d.length === 11 && d.charAt(0) === '1') d = d.slice(1);
      if (d.length === 10) return { number: '+1' + d };
    }
    return { error: 'Add your mobile number with its country code.' };
  }
  function actualCountryIso(number, selected) {
    if (!number || !selected || !window.intlTelInput || !window.intlTelInput.getAllCountries) return selected && selected.iso2;
    var all = window.intlTelInput.getAllCountries(), digits = String(number).replace(/\D/g, ''), dial = String(selected.dialCode || '');
    var national = digits.indexOf(dial) === 0 ? digits.slice(dial.length) : digits, found = null, len = 0;
    for (var i = 0; i < all.length; i++) {
      var c = all[i]; if (String(c.dialCode) !== dial || !c.areaCodes) continue;
      for (var j = 0; j < c.areaCodes.length; j++) { var pre = String(c.areaCodes[j]); if (pre.length > len && national.indexOf(pre) === 0) { found = c.iso2; len = pre.length; } }
    }
    return found || selected.iso2;
  }
  function readPhone(input) {
    if (!String((input && input.value) || '').trim()) return { error: 'Add your mobile number.' };
    var iti = initPhoneInput(input);
    if (!iti || !window.intlTelInput || !window.intlTelInput.utils) return fallbackPhone(input);
    var sel = iti.getSelectedCountry();
    if (!sel || !SMS_MAP[sel.iso2]) return { error: 'Choose a country that can receive texts.' };
    if (!iti.isValidNumber()) {
      var code = iti.getValidationError(), V = window.intlTelInput.VALIDATION_ERROR || {};
      if (code === V.INVALID_COUNTRY_CODE) return { error: 'Choose the correct country code.' };
      if (code === V.TOO_SHORT) return { error: 'That number is too short for ' + sel.name + '.' };
      if (code === V.TOO_LONG) return { error: 'That number is too long for ' + sel.name + '.' };
      return { error: "That doesn't look like a valid mobile number." };
    }
    var number = iti.getNumber();
    if (!/^\+[1-9][0-9]{6,14}$/.test(number)) return { error: "That phone number doesn't look complete." };
    if (!SMS_MAP[actualCountryIso(number, sel)]) return { error: "Texts aren't supported for that country yet." };
    return { number: number };
  }
  function withPhone(input, done) {
    ensurePhoneUtils();
    if (phoneUtilsPromise && window.intlTelInput && !window.intlTelInput.utils) {
      setClaimBusy(true, 'Checking…');
      var fin = function () { setClaimBusy(false); done(readPhone(input)); };
      Promise.race([phoneUtilsPromise, wait(5000)]).then(fin, fin);
    } else done(readPhone(input));
  }

  /* ---------- sizes and checkout ---------- */
  var sizesEl = $('ffp-sizes'), buy = $('ffp-buy'), buyBusy = false;
  var sizeBtns = Array.prototype.slice.call(sizesEl.querySelectorAll('.ffp-size'));
  function pickSize(btn, focus) {
    sizeBtns.forEach(function (b) { var on = b === btn; b.setAttribute('aria-checked', on ? 'true' : 'false'); b.tabIndex = on ? 0 : -1; });
    S.size = { id: btn.getAttribute('data-size'), variant: btn.getAttribute('data-variant'), label: btn.getAttribute('data-label'), price: btn.getAttribute('data-price') };
    setText('ffp-desc', btn.getAttribute('data-desc') || '');
    $('ffp-nag').hidden = true;
    buyLabel(false);
    stickySize(btn);
    buy.setAttribute('aria-disabled', 'false');
    buy.href = checkoutHref();
    if (focus) btn.focus();
  }
  sizeBtns.forEach(function (b, i) {
    b.tabIndex = i === 0 ? 0 : -1;
    b.addEventListener('click', function () { pickSize(b); buzz(8); });
    b.addEventListener('keydown', function (e) {
      var k = e.key, j = k === 'ArrowRight' || k === 'ArrowDown' ? i + 1 : k === 'ArrowLeft' || k === 'ArrowUp' ? i - 1 : null;
      if (j === null) return;
      e.preventDefault(); pickSize(sizeBtns[(j + sizeBtns.length) % sizeBtns.length], true);
    });
  });
  /* the buy button's words, and the phone bar's beside it (the bar shows the price on its left). Until a size is
     picked the bar's button says what it does then: Choose my size. */
  function buyLabel(busy) {
    var base = C.buy || 'Secure my portrait';
    setText('ffp-buy-l', busy ? 'Opening checkout…' : S.size ? base + ' · ' + S.size.price : base);
    setText('ffp-sticky-go', busy ? 'Opening checkout…' : S.size ? base : (C.choose || 'Choose my size'));
  }
  function checkoutHref() {
    var a = ['attributes%5Bff_source%5D=fast-pass'];
    if (S.code) a.push('attributes%5Bff_fast_pass%5D=' + encodeURIComponent(S.code));
    if (S.token) a.push('attributes%5Bffq_token%5D=' + encodeURIComponent(S.token));
    /* an earned pass: the quest's session lets the portal fill the brief from the blueprint (PORTAL-96) */
    if (S.questSession) a.push('attributes%5Bff_quest_session%5D=' + encodeURIComponent(S.questSession));
    if (S.heroId) a.push('attributes%5Bff_hero_id%5D=' + encodeURIComponent(S.heroId));
    return '/cart/' + encodeURIComponent(S.size ? S.size.variant : '') + ':1?' + a.join('&');
  }
  /* smooth from the phone bar, which can be a long way down the page; the buy button sits under the sizes */
  function nag(smooth) {
    var n = $('ffp-nag'); n.hidden = false;
    sizesEl.classList.remove('is-nag'); void sizesEl.offsetWidth; sizesEl.classList.add('is-nag');
    try { sizesEl.scrollIntoView(smooth ? { block: 'center', behavior: RM ? 'auto' : 'smooth' } : { block: 'center' }); } catch (e) { try { sizesEl.scrollIntoView(); } catch (x) {} }
  }
  buy.addEventListener('click', function (e) {
    e.preventDefault();
    if (!S.size) { nag(); return; }
    if (buyBusy) return;
    if (PREVIEW) { setText('ffp-desc', 'Preview. Checkout opens here for the person you send this to.'); return; }
    buyBusy = true;
    buyLabel(true);
    var price = parseFloat(String(S.size.price).replace(/[^0-9.]/g, '')) || 0;
    pixel('track', 'InitiateCheckout', { content_name: S.size.label, value: price, currency: 'USD' });
    track('checkout', { ff_fast_pass_size: S.size.id });
    /* a new joiner's token is usually back by now; wait a little for it so the portal can match the order */
    Promise.race([joinP || Promise.resolve(), wait(6000)]).then(function () {
      var counted = S.code ? rpcBeacon('fastpass_checkout', { p_code: S.code, p_size: S.size.id }) : Promise.resolve();
      return Promise.race([counted, wait(350)]);
    }).then(function () { window.location.href = checkoutHref(); });
    setTimeout(function () { buyBusy = false; if (S.size) buyLabel(false); }, 9000);
  });
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) { buyBusy = false; if (S.size) buyLabel(false); }
  });
  var endBtn = $('ffp-end-btn');
  if (endBtn) endBtn.addEventListener('click', function (e) {
    e.preventDefault();
    try { sizesEl.scrollIntoView({ block: 'center', behavior: RM ? 'auto' : 'smooth' }); } catch (x) { sizesEl.scrollIntoView(); }
  });

  /* ---------- phones: the buy bar (Jan, 2026-10-12), modelled on the D&D product page's sticky bar ----------
     On a phone the closing line and its button step aside (CSS). This bar slides up once the size picker has
     scrolled away above, and leaves whenever the sizes or the buy button are on screen. Before a size it reads
     "Your portrait, From $99" and "Choose my size", which glides back to the sizes. With a size it shows the
     size and its price, and its button is the buy button's own click, so the pixel, the count and the checkout
     link are the buy button's, once. Only while the pass is open for buying: never before it opens, after it ends, or
     on a pass that is off. Desktop keeps the closing line (CSS hides this bar there). */
  var sticky = $('ffp-sticky'), stickyOn = false, stickyTick = false, PHONE = null;
  try { PHONE = window.matchMedia('(max-width: 759px)'); } catch (e) {}
  function canBuy() { return (S.stage === 'line' || S.stage === 'bought') && revealed && !$('ffp-offer').hidden; }
  function setSticky(on) {
    if (on === stickyOn) return;
    stickyOn = on;
    sticky.classList[on ? 'add' : 'remove']('is-on');
    sticky.setAttribute('aria-hidden', on ? 'false' : 'true');
    root.classList[on ? 'add' : 'remove']('has-sticky');
    document.body.classList[on ? 'add' : 'remove']('ffp-sticky-on');
  }
  function stickyCheck() {
    stickyTick = false;
    var on = false;
    if (!lbOpen && PHONE && PHONE.matches && canBuy()) {
      var vh = window.innerHeight || 700, rs = sizesEl.getBoundingClientRect(), rb = buy.getBoundingClientRect();
      var seen = function (r) { return r.bottom > 0 && r.top < vh; };
      on = rs.bottom <= 0 && !seen(rs) && !seen(rb);
    }
    setSticky(on);
  }
  function stickyLater() { if (!stickyTick) { stickyTick = true; requestAnimationFrame(stickyCheck); } }
  /* the chosen size's picture, name and price */
  function stickySize(btn) {
    if (!S.size) return;
    setText('ffp-sticky-l', S.size.label);
    var p = $('ffp-sticky-p'), b = document.createElement('b');
    p.textContent = ''; b.textContent = S.size.price; p.appendChild(b);
    var im = btn && btn.querySelector('img'), si = $('ffp-sticky-img');
    if (im && si && si.getAttribute('src') !== im.getAttribute('src')) si.setAttribute('src', im.getAttribute('src'));
  }
  window.addEventListener('scroll', stickyLater, { passive: true });
  window.addEventListener('resize', stickyLater, { passive: true });
  /* no size yet: "Choose my size" glides to the sizes; with a size it is the buy button's own click */
  $('ffp-sticky-go').addEventListener('click', function () { if (!S.size) { nag(true); return; } buy.click(); });
  window.__ffp.sticky = function () { return stickyOn; };

  /* ---------- reviews: Loox, the same photo reviews as the product page, after the offer shows ----------
     The first page fills the cards (pinned ones first, five stars, a real sentence, a photo). "Load more reviews"
     (Jan, 2026-10-12) adds the next ones under them in the same card, four on a phone and six on a desktop (even
     rows: two columns on both, smaller cards on a phone), from the rest of that page and then the next pages. A review already on the page
     never shows twice (its id, its picture or its words). A batch waits for its pictures, so a broken one never
     leaves a hole or a jump. */
  var REV = { started: false, firstOk: false, page: 0, done: false, busy: false, failed: false, pool: [], seen: {}, base: '' }, LOOX_PAGE = 60;
  /* the green check the four cards in the section carry, so every card wears the same one */
  var VER_SVG = (function () { var v = document.querySelector('.ffp-rev__ver svg'); return v ? v.outerHTML : ''; })();
  var moreEl = $('ffp-more'), moreGo = $('ffp-more-go'), moreBtn = $('ffp-more-btn');
  function looxGet(u) { return fetch(u, { credentials: 'omit' }).then(function (r) { if (!r.ok) throw new Error('loox ' + r.status); return r.json(); }); }
  function looxPhoto(r) {
    var o = CFG.loox.overrides[r.id]; if (o && o.image) return o.image;
    var m = (r.media || []).filter(function (x) { return x && x.type === 'photo' && x.url; })[0];
    return m ? String(m.url).replace(/_orig\.jpg$/i, '_mid.jpg') : '';
  }
  function imgKey(u) { return String(u || '').split('?')[0].replace(/^https?:\/\/[^/]+/i, '').toLowerCase(); }
  function bodyKey(t) { return String(t || '').toLowerCase().replace(/[^a-z0-9]+/g, '').slice(0, 60); }
  function keysOf(c) { return ['i:' + c.id, 'm:' + imgKey(c.img), 'b:' + bodyKey(c.body)]; }
  function isSeen(c) { return keysOf(c).some(function (k) { return REV.seen[k]; }); }
  function markSeen(c) { keysOf(c).forEach(function (k) { REV.seen[k] = 1; }); }
  function toCard(r) {
    var L = CFG.loox, id = r && r.id;
    if (!r || !id || (r.rating || 0) < 5 || String(r.body || '').trim().length < 60) return null;
    var img = looxPhoto(r); if (!img) return null;
    return { id: id, name: (L.overrides[id] && L.overrides[id].author) || (r.reviewer && r.reviewer.name) || 'Verified buyer', verified: !!r.verified, body: String(r.body).trim(), img: img };
  }
  function revCard(r) {
    var a = document.createElement('article'); a.className = 'ffp-rev';
    a.innerHTML = '<div class="ffp-rev__img"><img loading="lazy" decoding="async" alt=""></div><div class="ffp-rev__body"><p class="ffp-rev__who"><span></span></p><p class="ffp-rev__q"></p></div>';
    var img = a.querySelector('img'); img.src = r.img; img.alt = 'Portrait from ' + r.name + "'s review";
    img.addEventListener('error', function () { a.remove(); });
    a.querySelector('.ffp-rev__who span').textContent = r.name;
    if (r.verified) {
      var v = document.createElement('span'); v.className = 'ffp-rev__ver'; v.innerHTML = VER_SVG;
      v.appendChild(document.createTextNode('Verified')); a.querySelector('.ffp-rev__who').appendChild(v);
    }
    a.querySelector('.ffp-rev__q').textContent = r.body;
    return a;
  }
  /* the next page of Loox reviews as cards nobody has seen yet; the first page also brings the pinned ones */
  function looxPage() {
    var L = CFG.loox, n = REV.page + 1;
    return looxGet(REV.base + '/product-reviews?product_id=' + L.product + '&sort=featured&limit=' + LOOX_PAGE + '&page=' + n).then(function (j) {
      var all = (j && j.reviews) || [], byId = {};
      all.forEach(function (r) { if (r && r.id) byId[r.id] = r; });
      var extra = n !== 1 ? Promise.resolve([]) : Promise.all(L.pinned.filter(function (id) { return !byId[id]; }).map(function (id) {
        return looxGet(REV.base + '/product-reviews/' + encodeURIComponent(id)).then(function (x) { return x && x.review; }, function () { return null; });
      }));
      return extra.then(function (more) {
        more.forEach(function (r) { if (r && r.id) byId[r.id] = r; });
        REV.page = n;
        if (all.length < LOOX_PAGE) REV.done = true;
        var ids = (n === 1 ? L.pinned : []).concat(all.map(function (r) { return r && r.id; })), out = [], here = {};
        ids.forEach(function (id) {
          if (!id || here[id]) return; here[id] = 1;
          var c = toCard(byId[id]); if (!c || isSeen(c)) return;
          if (out.some(function (o) { return keysOf(o).some(function (k) { return keysOf(c).indexOf(k) >= 0; }); })) return;
          out.push(c);
        });
        return out;
      });
    });
  }
  function loadReviews() {
    if (REV.started || !CFG.loox || !window.fetch) return; REV.started = true;
    var L = CFG.loox;
    REV.base = String(L.api || 'https://storefront-api.loox.io/storefront/v1/store/') + encodeURIComponent(L.store);
    looxGet(REV.base + '/product-reviews/bottomline/' + L.product).then(function (b) {
      if (b && b.totalReviews > 100) setText('ffp-rev-count', b.totalReviews.toLocaleString());
    }).catch(function () {});
    looxPage().then(function (list) {
      /* fewer than four: the four cards in the section stay, as before */
      if (!list || list.length < 4) return;
      var first = list.slice(0, 8); first = first.slice(0, first.length - (first.length % 2));
      var rail = $('ffp-rail'), frag = document.createDocumentFragment();
      first.forEach(function (r) { markSeen(r); frag.appendChild(revCard(r)); });
      rail.textContent = ''; rail.appendChild(frag);
      REV.firstOk = true;
      REV.pool = list.slice(first.length);
      if (REV.pool.length || !REV.done) moreGo.hidden = false;
    }).catch(function () {});
  }
  function moreBusy(on) {
    REV.busy = on;
    moreBtn.setAttribute('aria-busy', on ? 'true' : 'false');
    setText('ffp-more-l', on ? 'Loading…' : REV.failed ? 'Try again' : 'Load more reviews');
  }
  /* wait for a batch's pictures (up to 6 seconds); one that fails is left out */
  function preload(cards) {
    return Promise.all(cards.map(function (c) {
      return new Promise(function (res) {
        var im = new Image(), t = setTimeout(function () { res(c); }, 6000);
        im.onload = function () { clearTimeout(t); res(c); };
        im.onerror = function () { clearTimeout(t); res(null); };
        im.src = c.img;
      });
    })).then(function (a) { return a.filter(Boolean); });
  }
  /* a placeholder in the same card: holds a slow batch's place, so its reviews land without pushing anything below */
  function skelCard() {
    var a = document.createElement('article'); a.className = 'ffp-rev is-skel'; a.setAttribute('aria-hidden', 'true');
    a.innerHTML = '<div class="ffp-rev__img"></div><div class="ffp-rev__body"><p class="ffp-rev__who"><span>Verified buyer</span></p><p class="ffp-rev__q"></p></div>';
    a.querySelector('.ffp-rev__q').textContent = new Array(13).join('A review is on its way here. ');
    return a;
  }
  function loadMore() {
    if (REV.busy || !REV.firstOk) return;
    var desk = !(PHONE && PHONE.matches), need = desk ? 6 : 4, got = [];
    moreBusy(true);
    setText('ffp-more-err', '');
    /* a batch that is not ready almost at once (a new Loox page, slow pictures) gets placeholders while the tap is
       still fresh, so the page moves at the tap and never again when the reviews arrive */
    var skel = [], skelT = setTimeout(function () {
      if (!REV.busy) return;
      var f = document.createDocumentFragment();
      for (var i = 0; i < need; i++) { var s = skelCard(); skel.push(s); f.appendChild(s); }
      moreEl.appendChild(f);
    }, 150);
    function unskel() { clearTimeout(skelT); skel.forEach(function (s) { s.remove(); }); skel = []; }
    function fill() {
      if (REV.pool.length >= need - got.length || REV.done) return Promise.resolve();
      return looxPage().then(function (cards) {
        var queued = {};
        REV.pool.concat(got).forEach(function (c) { keysOf(c).forEach(function (k) { queued[k] = 1; }); });
        REV.pool = REV.pool.concat(cards.filter(function (c) { return !isSeen(c) && !keysOf(c).some(function (k) { return queued[k]; }); }));
        return fill();
      });
    }
    function round(k) {
      return fill().then(function () {
        var take = REV.pool.splice(0, need - got.length);
        return preload(take).then(function (ok) {
          got = got.concat(ok);
          if (got.length < need && k < 3 && (REV.pool.length || !REV.done)) return round(k + 1);
        });
      });
    }
    round(1).then(function () {
      var more = REV.pool.length || !REV.done;
      /* two columns on a phone and a desktop: an odd card waits for the next batch, and the very last odd one stays
         out; a lone card with more to come shows anyway, so a tap never ends with nothing added */
      if (got.length % 2 && (got.length > 1 || !more)) { var odd = got.pop(); if (more) REV.pool.unshift(odd); }
      var frag = document.createDocumentFragment(), firstNew = null;
      got.forEach(function (c) { markSeen(c); var a = revCard(c); if (!firstNew) firstNew = a; frag.appendChild(a); });
      /* the reviews take the placeholders' place in the same frame */
      moreEl.insertBefore(frag, skel[0] || null); unskel();
      REV.failed = false;
      moreBusy(false);
      more = REV.pool.length || !REV.done;
      say(got.length ? got.length + ' more reviews.' : more ? '' : 'No more reviews.');
      if (!more) {
        /* nothing left: the button goes, and focus moves to the first new review instead of nowhere */
        var had = document.activeElement === moreBtn;
        moreGo.hidden = true;
        if (had && firstNew) { firstNew.tabIndex = -1; try { firstNew.focus({ preventScroll: true }); } catch (e) {} }
      }
    }, function () {
      /* the cards this tap already had wait for the next one */
      REV.pool = got.concat(REV.pool); got = [];
      unskel();
      REV.failed = true;
      moreBusy(false);
      setText('ffp-more-err', "Those reviews didn't load.");
    });
  }
  moreBtn.addEventListener('click', loadMore);
  window.__ffp.reviews = REV;

  /* ---------- start ---------- */
  if (PREVIEW) {
    var chip = document.createElement('span'); chip.className = 'ffp-preview'; chip.textContent = 'Preview. Nothing is saved.'; root.appendChild(chip);
    var sample = { ok: true, code: null, kind: 'person', name: 'Sarah', state: 'waiting', position: 214, total: 389, eta_days: 26, est_wait: '3 to 5 weeks',
      /* nobody in the sample line shares a name with a sample hero (the earned previews are Brannoc's) */
      list: [{ p: 1, n: 'Aria' }, { p: 2, n: 'Bryn' }, { p: 3, n: 'Corin' }, { p: 4, n: 'Dalia' }, { p: 5, n: 'Eamon' }] };
    sample.stage = PREVIEW === 'claim' ? 'phone' : PREVIEW;
    if (PREVIEW === 'claim') { sample.position = null; sample.eta_days = null; }
    if (PREVIEW === 'bought') sample.order = '#2301';
    if (/^(soon|earned|ended)$/.test(PREVIEW)) {
      /* a line skip earned in the portal: soon opens in 11 hours 42 minutes, earned is open, ended is over */
      var t0 = Date.now(), HR = 3600000, op = PREVIEW === 'soon' ? t0 + 11.7 * HR : PREVIEW === 'earned' ? t0 - HR : t0 - 50 * HR;
      sample = { ok: true, code: null, kind: 'earned', stage: PREVIEW === 'earned' ? 'line' : PREVIEW, name: 'Brannoc', hero_name: 'Brannoc',
        signed: 'Sam', size: 'thigh', opens_at: new Date(op).toISOString(), ends_at: new Date(op + 48 * HR).toISOString(), now: new Date(t0).toISOString(),
        plan: { pose: 'Mid-swing, axe raised', vibe: 'Grim and steady', bg: 'A burning keep at night' },
        has_line: true, in_line: true, total: 389, position: 214, eta_days: null, token: null, est_wait: '3 to 5 weeks', list: sample.list };
    }
    /* a past client's answer lands with the pass, as it usually does live */
    setTimeout(function () { apply(sample); if (PREVIEW_PAST && sample.kind !== 'earned') setPast(true, PREVIEW_SHOP); }, 250);
    return;
  }
  /* The section's first lines lift ?pass= out of the address before the store's trackers load (window.__ffpPass);
     this strips it again in case they did not run. The code is saved on this phone at once, so a reload finds it. */
  var urlCode = String(window.__ffpPass != null ? window.__ffpPass : (qs.get('pass') || '')).trim();
  try {
    if (/[?&]pass=/.test(window.location.search)) {
      var u = new URL(window.location.href); u.searchParams.delete('pass');
      window.history.replaceState(window.history.state, '', u.pathname + u.search + u.hash);
    }
  } catch (e) {}
  var savedPass = readJSON(PASS_KEY) || {}, live = readJSON(LIVE_KEY) || {};
  priorPass = savedPass.code ? savedPass : null;
  var bootCode = (urlCode ? urlCode.toUpperCase() : null) || passCode(savedPass.code) || null;
  var urlPass = passCode(urlCode);
  if (urlPass && urlPass !== savedPass.code) writeJSON(PASS_KEY, { code: urlPass, at: Date.now() });
  var bootToken = UUID.test(live.token || '') ? live.token : null;
  track('opened', { ff_fast_pass_personal: !!urlCode });
  boot();
  function boot() {
    askedCode = bootCode;
    /* asked alongside the pass. The pass waits up to 1.5 s for it, so an Etsy client's line is drawn once, not
       swapped a moment later; a slower answer still lands when it comes. */
    var pastP = pastFor(passCode(bootCode));
    rpc('fastpass_open', { p_code: bootCode, p_token: bootToken }, 12000).then(function (r) {
      return Promise.race([pastP, wait(1500)]).then(function () { apply(r); checkPast(); });
    }, function () { show(isEarnedCode(bootCode) ? 'retry' : 'claim'); });
  }
})();
